import { useEffect, useState } from "react"
import axiosInstance from "../../utils/axios-instance"
import { UserAgencyModelType } from "../../types/user-types"
import SingleAgencyDetails from "./single-agency-details"
import PaginationMenu from "../pagination/paginationMenu"
import Button from "../button/Button"
import CreateNewAgency from "../../models/create-new-agency"

interface IAgencies {
    totalCount: 0,
    data: UserAgencyModelType[]
}

const AgencySettings = () => {
    const [agencies, setAgencies] = useState<IAgencies>({
        totalCount: 0,
        data: []
    })
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [createAgency, setCreateAgency] = useState(false)

    useEffect(() => {
        const findAgencies = async () => {
            try {
                const res = await axiosInstance.get(`/agencies?limit=${limit}&page=${page}`)
                setAgencies(res.data)
            } catch (error) {
                console.log(error)
            }
        }

        findAgencies()
    }, [page, limit])


    const onSetPage = (page) => {
        setPage(page)
    }


    const ToggleAgencyPopup = () => [
        setCreateAgency(!createAgency)
    ]

    return (
        <div className='w-[95%] mx-auto py-12'>
            <div className="w-full flex items-center justify-between mb-6">
                <div>
                    <h2 className="font-display text-2xl text-lightBlack font-semibold tracking-tight">Agencies</h2>
                    <p className="text-sm text-gray-500 mt-1">Manage agency accounts and subscriptions.</p>
                </div>
                <div className="w-auto">
                    <Button className="!w-auto !px-6" onClick={ToggleAgencyPopup}>+ Create Agency</Button>
                </div>
            </div>

            <div className="w-full bg-white border border-gray-100 rounded-2xl overflow-hidden shadow-soft">
                <div className='grid grid-cols-6 gap-x-3 bg-gray-50 text-lightBlack py-4 px-6 border-b border-gray-100 text-xs font-medium uppercase tracking-wider'>
                    <div className='text-start'>Name</div>
                    <div>Email</div>
                    <div>Users</div>
                    <div>Subscription</div>
                    <div>Status</div>
                    <div className='text-end'>Joined On</div>
                </div>
                <div>
                    {agencies.data.map((item) => {
                        return (
                            <SingleAgencyDetails item={item} key={item.id} />
                        )
                    })}
                </div>
            </div>

            <div className="mt-4">
                <PaginationMenu onPageChange={onSetPage} totalCount={agencies.totalCount} currentPage={page} pageSize={limit} />
            </div>

            {createAgency ? <CreateNewAgency toggleUserModel={ToggleAgencyPopup} /> : null}
        </div>
    )
}

export default AgencySettings
